export default function isUserId(userId: string): boolean {
  return (
    typeof userId === 'string' &&
    userId.length === 24 &&
    !!userId.match(/^[0-9a-f]{24}$/i)
  );
}
